import React from 'react';

const Footer = () => {
    const quickLinks = [
        { label: "About Us", href: "/About" },
        { label: "Administration", href: "/Administration" },
        { label: "Contact Us", href: "/Contact" },
        // { label: "Terms & Condition", href: "#" },
        // { label: "FAQs & Help", href: "#" }
    ];

    const contactInfo = [
        { icon: "fa-map-marker-alt", text: "MUDA Complex, First Floor, Kalidasa Road, Opp. Sony Center, First Stage, Vijayanagar, Mysore – 570017" },
        { icon: "fa-phone-alt", text: "0821-5211786" },
        { icon: "fa-envelope", text: "pricipal@mcmcollege.com" }
    ];

    const socialLinks = [
        { icon: "fab fa-twitter", href: "#" },
        { icon: "fab fa-facebook-f", href: "#" },
        { icon: "fab fa-youtube", href: "#" },
        { icon: "fab fa-linkedin-in", href: "#" }
    ];

    const footerMenu = [
        { label: "Home", href: "#" },
        { label: "Cookies", href: "#" },
        { label: "Help", href: "#" },
        { label: "FQAs", href: "#" }
    ];

    const galleryImages = [
        { src: "img/course-1.jpg", alt: "Course 1" },
        { src: "img/course-2.jpg", alt: "Course 2" },
        { src: "img/course-3.jpg", alt: "Course 3" },
        { src: "img/course-4.jpg", alt: "Course 4" },
        { src: "img/course-5.jpg", alt: "Course 5" },
        { src: "img/course-6.jpg", alt: "Course 6" }
    ];

    const handleNewsletterSubmit = (e) => {
        e.preventDefault();
        const email = e.target.email.value;
        console.log('Newsletter subscription:', email);
        // Add your newsletter subscription logic here
        e.target.reset();
    };

    const currentYear = new Date().getFullYear();

    return (
        <>
            <div className="container-fluid bg-dark text-light footer pt-5 mt-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container py-5">
                    <div className="row g-5">
                        {/* Quick Links */}
                        <div className="col-lg-3 col-md-6">
                            <h4 className="text-white mb-3">Quick Link</h4>
                            <div className="d-flex flex-column">
                                {quickLinks.map((link, index) => (
                                    <a 
                                        key={index}
                                        className="btn btn-link text-light text-decoration-none p-0 mb-2"
                                        href={link.href}
                                    >
                                        {link.label}
                                    </a>
                                ))}
                            </div>
                        </div>

                        {/* Contact Info */}
                        <div className="col-lg-3 col-md-6">
                            <h4 className="text-white mb-3">Contact</h4>
                            {contactInfo.map((info, index) => (
                                <p key={index} className="mb-2">
                                    <i className={`fa ${info.icon} me-3`}></i>
                                    {info.text}
                                </p>
                            ))}
                            <div className="d-flex pt-2">
                                {socialLinks.map((social, index) => (
                                    <a 
                                        key={index}
                                        className="btn btn-outline-light btn-social rounded-circle me-2"
                                        href={social.href}
                                        aria-label={social.icon.split('fa-')[1]}
                                    >
                                        <i className={social.icon}></i>
                                    </a>
                                ))}
                            </div>
                        </div>

                        {/* Gallery */}
                        {/* <div className="col-lg-3 col-md-6">
                            <h4 className="text-white mb-3">Gallery</h4>
                            <div className="row g-2">
                                {galleryImages.map((image, index) => (
                                    <div key={index} className="col-4">
                                        <img 
                                            src={image.src} 
                                            alt={image.alt}
                                            className="img-fluid rounded"
                                            style={{ width: '100%', height: '80px', objectFit: 'cover' }}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div> */}

                        {/* Newsletter */}
                        {/* <div className="col-lg-3 col-md-6">
                            <h4 className="text-white mb-3">Newsletter</h4>
                            <p className="mb-3">Dolor amet sit justo amet elitr clita ipsum elitr est.</p>
                            <form onSubmit={handleNewsletterSubmit} className="position-relative">
                                <div className="input-group">
                                    <input 
                                        name="email"
                                        type="email" 
                                        className="form-control border-0 py-3 ps-4"
                                        placeholder="Your email"
                                        required
                                        style={{ paddingRight: '100px' }}
                                    />
                                    <button 
                                        type="submit" 
                                        className="btn btn-primary position-absolute top-0 end-0 h-100"
                                        style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                    >
                                        Sign Up
                                    </button>
                                </div>
                            </form>
                        </div> */}
                    </div>
                </div>

                {/* Copyright Section */}
                <div className="container">
                    <div className="copyright py-4">
                        <div className="row">
                            <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                                <span className="text-light">
                                    &copy; {currentYear} <a className="text-white border-bottom text-decoration-none" href="#">
                                       S.K. Educational Society.
                                    </a>, All Rights Reserved.
                                </span>
                                <br />
                                <small className="text-muted">
                                    Managed & Maintained by  <a className="text-white border-bottom text-decoration-none" href="https://www.vssitcompany.com/">
                                       Veriteam Software
                                    </a>
                                </small>
                                <br />
                                
                            </div>
                            <div className="col-md-6 text-center text-md-end">
                                <div className="footer-menu">
                                    {footerMenu.map((item, index) => (
                                        <a 
                                            key={index}
                                            className="text-white text-decoration-none me-3"
                                            href={item.href}
                                        >
                                            {item.label}
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Footer;